<h1 mat-dialog-title>{{ data.title }}</h1>
<div mat-dialog-content>
  <mat-form-field appearance="outline" class="w-full">
    <mat-label>{{ data.label }}</mat-label>
    <input
      #textInput
      matInput
      cdkFocusInitial
      (focus)="textInput.select()"
      [(ngModel)]="data.text"
      [placeholder]="data.placeholder"
      (keyup.enter)="onAction(data.actions[0])" />
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <ng-container *ngFor="let action of data.actions || []; first as isFirst">
    <button
      *ngIf="!isFirst; else First"
      class="ml-4 w-40"
      mat-flat-button
      [color]="'default'"
      (click)="onAction(action)">
      {{ action }}
    </button>
    <ng-template #First>
      <button
        class="w-40"
        mat-flat-button
        color="primary"
        (click)="onAction(action)"
        [disabled]="!data.validFn(data.text)">
        {{ action }}
      </button>
    </ng-template>
  </ng-container>
</div>
